import React, {Component} from 'react';
import './SignUpComponent.less';
import {FormInput} from '@homeaway/react-form-components';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {apiPost} from '../../util/api.client';
import edapWrapper from '@homeaway/edap-wrapper';
const validate = require('validate.js');
const PASSWORD_MAX_LENGTH = 32;
const PASSWORD_MIN_LENGTH = 7;
const pwdLengthOptions = {'min': PASSWORD_MIN_LENGTH, 'max': PASSWORD_MAX_LENGTH};

class SignUpComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            firstName: '',
            lastName: '',
            password: '',
            loggedIn: false,
            errorMsg: '',
            enablePasswordHint: false,
            loading: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.checkStatus = this.checkStatus.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.triggerSubmit = this.triggerSubmit.bind(this);
        this.editEmail = this.editEmail.bind(this);
    }

    componentDidMount() {
        if (this.firstNameInput) {
            this.firstNameInput.focus();
        }
        edapWrapper().push({
            name: 'generic.event',
            data: {
                actionlocation: this.props.actionLocation,
                eventaction: 'signup.visible',
                eventcategory: 'lex',
                eventlabel: 'ums'
            }
        });
    }

    handleSubmit(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
        if (event.target.name === 'password') {
            if (event.target.value !== '') {
                this.setState({enablePasswordHint: true});
            } else {
                this.setState({enablePasswordHint: false});
            }
        }
    }

    handleError(error) {
        edapWrapper().push({
            name: 'generic.event',
            data: {eventaction: 'signup.failure', eventcategory: 'lex', eventlabel: 'ums', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.props.handleError(error);
    }

    signUpSuccess(json) {
        this.props.setEmail(this.state.emailAddress);
        this.props.setFirstName(this.state.firstName);
        this.setState({loggedIn: true});
        edapWrapper().push({
            name: 'generic.event',
            data: {eventaction: 'signup.success', eventcategory: 'lex', eventlabel: 'ums', publicuuid: json.publicUuid, actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        edapWrapper().push({
            name: 'login.success',
            data: {loginsource: 'lex', logintype: 'ums', publicuuid: json.publicUuid, actionLocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.props.setAuthJson(json);
        this.props.updatePage('success');
    }

    checkStatus(response) {
        switch (response.status) {
            case 200:
                response.json().then((json) => {
                    this.signUpSuccess(json);
                });
                break;
            case 400:
                this.props.disableLoading();
                let errorMessage = '';
                /* istanbul ignore next */
                response.json().then((json) => {
                    if (json.errors) {
                        let error = '';
                        for (error of json.errors) {
                            const options = error === 'ums.validation.password.length' ? pwdLengthOptions : null;
                            errorMessage += (errorMessage.length ? ' ' : '') + this.props.lingua.read(error, options, 'validation');
                        }
                        this.setState({errorMsg: errorMessage});
                        this.handleError(errorMessage);
                    } else {
                        this.handleError(this.props.lingua.read('error.generic'));
                    }
                });
                break;
            case 401:
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('error.authentication.credentials.bad'));
                break;
            case 409: // this should never happen since you would only get to this component after checking for existing user but just in case
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('ums.validation.email.unavailable'));
                break;
            default:
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('error.generic'));
                break;
        }
    }

    triggerSubmit(e) {
        e.preventDefault();
        this.props.enableLoading();
        setTimeout(() => {
            this.submitForm();
        }, 800);
    }

    submitForm() {
        if (!this.validatePassword(true)) {
            this.props.disableLoading();
            return;
        }
        edapWrapper().push({
            name: 'generic.event',
            data: {eventaction: 'signup.attempt', eventcategory: 'lex', eventlabel: 'ums', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        if (this.props.useNewEndpoints) {
            apiPost('/auth/aam/v3/register', {
                userName: this.state.emailAddress,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                secret: this.state.password,
                authType: 'HOMEAWAY',
                rememberMe: false
            }).then(this.checkStatus);
        } else {
            apiPost('/auth/v2/register', {
                emailAddress: this.state.emailAddress,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                password: this.state.password,
                registrationType: 'TRAVELER',
                service: this.props.service,
                source: this.props.site
            }).then(this.checkStatus);
        }
    }

    editEmail(e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.updatePage('initial');
    }

    validatePassword(displayErrors) {
        // Following is a fix to get regex to work, apparently it's a known issue
        validate.validators.regex = function(value, options) {
            let regExp = new RegExp(options.pattern);

            if (!regExp.test(value)) {
                return options.message;
            }
            return null;
        };
        let constraints = {p: {
            presence: true, regex: {
                pattern: '(?=.*?[0-9])(?=.*?[a-zA-Z])', message: 'ums.validation.password.regex'
            },

            length: {
                minimum: 7,
                maximum: 32,
                message: 'ums.validation.password.length'
            }
        }
        };
        let passwordValid = validate({p: this.state.password}, constraints);
        if (displayErrors && passwordValid && passwordValid.p.length > 0) {
            let error;
            let errorMessage = '';
            for (error of passwordValid.p) {
                error = error.substr(2);
                const options = error === 'ums.validation.password.length' ? pwdLengthOptions : null;
                errorMessage += (errorMessage.length ? ' ' : '') + this.props.lingua.read(error, options, 'validation');
            }
            this.setState({errorMsg: errorMessage});
            this.props.handleError(errorMessage);
        }
        return !passwordValid;
    }

    validateFields() {
        if (this.state.firstName === '' || this.state.lastName === '' || this.state.password === '' || !this.validatePassword(false)) {
            return false;
        }
        return true;
    }

    render() {
        let passwordFieldClasses = `form-group floating-label ${this.state.password === '' ? '' : 'not-empty'} has-feedback ${this.state.errorMsg === '' ? '' : 'has-error'}`;
        return (
            <div className="SignUpComponent text-center">
                <form onSubmit={this.triggerSubmit} noValidate>
                    <p className="email-display">{this.state.emailAddress}</p>
                    {!this.props.multiUserEnabled && <a onClick={this.editEmail} className="edit-email" href="">{this.props.lingua.read('lex.email.edit')}</a>}
                    <FormInput
                        id="lex-first-name"
                        className= "first-name"
                        name = "firstName"
                        label = {this.props.lingua.read('form.placeholder.firstName')}
                        value = {this.state.firstName}
                        onChange = {this.handleChange}
                        type= "text"
                        autoComplete = "firstName"
                        ref= {(input) => {
                            this.firstNameInput = input;
                        }}
                    />

                    <FormInput
                        id="lex-lastName"
                        name = "lastName"
                        label = {this.props.lingua.read('form.placeholder.lastName')}
                        value = {this.state.lastName}
                        onChange = {this.handleChange}
                        type= "text"
                        autoComplete = "lastName"
                    />
                    <div className={passwordFieldClasses}>
                        <label>{this.props.lingua.read('lex.password.prompt')}</label>
                        <input type={this.props.passwordType} className="form-control" aria-label={this.props.lingua.read('lex.password.prompt')}
                            name="password" onChange={this.handleChange} value={this.state.password} autoComplete = "new-password"
                        />
                        <span className="PasswordShow" onClick={this.props.showHidePassword}>
                            {(this.props.passwordType === 'input') ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')}
                        </span>
                        <span className={this.state.errorMsg === '' ? '' : 'help-block'}>{this.state.errorMsg}</span>
                    </div>
                    {this.state.enablePasswordHint && <label className="text-left">{this.props.lingua.read('lex.password.requirements', pwdLengthOptions)}</label>}
                    <div className="Signup_button">
                        <ButtonPrimary type="submit" label={this.props.lingua.read('account.signup.link.text')} disabled={!this.validateFields()}>
                            <LoadingOverlay loading={this.props.isWaiting}/>
                        </ButtonPrimary>
                    </div>
                </form>
            </div>
        );
    }
}

export default SignUpComponent;
